import errorCatchersStorage from '../helpers/error-catchers-storage';

function registerCatcher(callback) {
  errorCatchersStorage.add(callback);
}

export default registerCatcher;
